// This file is automatically generated by internal/scripts/refresh-assets.ts.
// Do not edit manually. Or do, I'm a comment, not a cop.

/** @public */
export type TLUiTranslationKey =
	| 'action.toggle-auto-pan'
	| 'action.toggle-auto-zoom'
	| 'action.toggle-auto-none'
	| 'action.toggle-mouse'
	| 'action.toggle-trackpad'
	| 'action.convert-to-bookmark'
	| 'action.convert-to-embed'
	| 'action.open-embed-link'
	| 'action.align-bottom'
	| 'action.align-center-horizontal'
	| 'action.align-center-vertical'
	| 'action.align-center-horizontal.short'
	| 'action.align-center-vertical.short'
	| 'action.align-left'
	| 'action.align-right'
	| 'action.align-top'
	| 'action.back-to-content'
	| 'action.bring-forward'
	| 'action.bring-to-front'
	| 'action.copy-as-json.short'
	| 'action.copy-as-json'
	| 'action.copy-as-png.short'
	| 'action.copy-as-png'
	| 'action.copy-as-svg.short'
	| 'action.copy-as-svg'
	| 'action.copy'
	| 'action.cut'
	| 'action.delete'
	| 'action.unlock-all'
	| 'action.distribute-horizontal'
	| 'action.distribute-vertical'
	| 'action.distribute-horizontal.short'
	| 'action.distribute-vertical.short'
	| 'action.download-original'
	| 'action.duplicate'
	| 'action.edit-link'
	| 'action.exit-pen-mode'
	| 'action.export-as-png.short'
	| 'action.export-as-png'
	| 'action.export-as-svg.short'
	| 'action.export-as-svg'
	| 'action.export-all-as-png.short'
	| 'action.export-all-as-png'
	| 'action.export-all-as-svg.short'
	| 'action.export-all-as-svg'
	| 'action.fit-frame-to-content'
	| 'action.flip-horizontal'
	| 'action.flip-vertical'
	| 'action.flip-horizontal.short'
	| 'action.flip-vertical.short'
	| 'action.fork-project'
	| 'action.fork-project-on-tldraw'
	| 'action.group'
	| 'action.insert-embed'
	| 'action.insert-media'
	| 'action.leave-shared-project'
	| 'action.new-project'
	| 'action.new-shared-project'
	| 'action.open-cursor-chat'
	| 'action.open-kbd-shortcuts'
	| 'action.open-file'
	| 'action.pack'
	| 'action.paste'
	| 'action.paste-error-title'
	| 'action.paste-error-description'
	| 'action.print'
	| 'action.redo'
	| 'action.remove-frame'
	| 'action.rename'
	| 'action.rotate-ccw'
	| 'action.rotate-cw'
	| 'action.save-copy'
	| 'action.select-all'
	| 'action.select-none'
	| 'action.send-backward'
	| 'action.send-to-back'
	| 'action.share-project'
	| 'action.stack-horizontal'
	| 'action.stack-vertical'
	| 'action.stack-horizontal.short'
	| 'action.stack-vertical.short'
	| 'action.stop-following'
	| 'action.stretch-horizontal'
	| 'action.stretch-vertical'
	| 'action.stretch-horizontal.short'
	| 'action.stretch-vertical.short'
	| 'action.toggle-auto-size'
	| 'action.toggle-dark-mode.menu'
	| 'action.toggle-dark-mode'
	| 'action.toggle-paste-at-cursor.menu'
	| 'action.toggle-paste-at-cursor'
	| 'action.toggle-wrap-mode.menu'
	| 'action.toggle-wrap-mode'
	| 'action.toggle-reduce-motion.menu'
	| 'action.toggle-reduce-motion'
	| 'action.toggle-keyboard-shortcuts.menu'
	| 'action.toggle-keyboard-shortcuts'
	| 'action.enhanced-a11y-mode.menu'
	| 'action.enhanced-a11y-mode'
	| 'action.toggle-edge-scrolling.menu'
	| 'action.toggle-edge-scrolling'
	| 'action.toggle-invert-zoom.menu'
	| 'action.toggle-invert-zoom'
	| 'action.toggle-debug-mode.menu'
	| 'action.toggle-debug-mode'
	| 'action.toggle-focus-mode.menu'
	| 'action.toggle-focus-mode'
	| 'action.toggle-dynamic-size-mode.menu'
	| 'action.toggle-dynamic-size-mode'
	| 'action.toggle-grid.menu'
	| 'action.toggle-grid'
	| 'action.toggle-lock'
	| 'action.flatten-to-image'
	| 'action.toggle-snap-mode.menu'
	| 'action.toggle-snap-mode'
	| 'action.toggle-tool-lock.menu'
	| 'action.toggle-tool-lock'
	| 'action.toggle-transparent.context-menu'
	| 'action.toggle-transparent.menu'
	| 'action.toggle-transparent'
	| 'action.undo'
	| 'action.ungroup'
	| 'action.zoom-in'
	| 'action.zoom-out'
	| 'action.zoom-to-100'
	| 'action.zoom-to-fit'
	| 'action.zoom-to-selection'
	| 'action.zoom-quick'
	| 'action.select-zoom-tool'
	| 'assets.files.size-too-big'
	| 'assets.files.maximum-size'
	| 'assets.files.type-not-allowed'
	| 'assets.files.upload-failed'
	| 'assets.files.amount-too-many'
	| 'assets.url.failed'
	| 'theme.dark'
	| 'theme.light'
	| 'theme.system'
	| 'color-style.white'
	| 'color-style.black'
	| 'color-style.blue'
	| 'color-style.green'
	| 'color-style.grey'
	| 'color-style.light-blue'
	| 'color-style.light-green'
	| 'color-style.light-red'
	| 'color-style.light-violet'
	| 'color-style.orange'
	| 'color-style.red'
	| 'color-style.violet'
	| 'color-style.yellow'
	| 'fill-style.none'
	| 'document.default-name'
	| 'fill-style.semi'
	| 'fill-style.solid'
	| 'fill-style.pattern'
	| 'fill-style.fill'
	| 'fill-style.lined-fill'
	| 'dash-style.dashed'
	| 'dash-style.dotted'
	| 'dash-style.draw'
	| 'dash-style.solid'
	| 'size-style.s'
	| 'size-style.m'
	| 'size-style.l'
	| 'size-style.xl'
	| 'opacity-style.0.1'
	| 'opacity-style.0.25'
	| 'opacity-style.0.5'
	| 'opacity-style.0.75'
	| 'opacity-style.1'
	| 'font-style.draw'
	| 'font-style.sans'
	| 'font-style.serif'
	| 'font-style.mono'
	| 'align-style.start'
	| 'align-style.middle'
	| 'align-style.end'
	| 'align-style.justify'
	| 'verticalAlign-style.start'
	| 'verticalAlign-style.middle'
	| 'verticalAlign-style.end'
	| 'geo-style.arrow-down'
	| 'geo-style.arrow-left'
	| 'geo-style.arrow-right'
	| 'geo-style.arrow-up'
	| 'geo-style.cloud'
	| 'geo-style.diamond'
	| 'geo-style.ellipse'
	| 'geo-style.heart'
	| 'geo-style.hexagon'
	| 'geo-style.octagon'
	| 'geo-style.oval'
	| 'geo-style.pentagon'
	| 'geo-style.rectangle'
	| 'geo-style.rhombus'
	| 'geo-style.rhombus-2'
	| 'geo-style.star'
	| 'geo-style.trapezoid'
	| 'geo-style.triangle'
	| 'geo-style.x-box'
	| 'geo-style.check-box'
	| 'arrowheadStart-style.none'
	| 'arrowheadStart-style.arrow'
	| 'arrowheadStart-style.bar'
	| 'arrowheadStart-style.diamond'
	| 'arrowheadStart-style.dot'
	| 'arrowheadStart-style.inverted'
	| 'arrowheadStart-style.pipe'
	| 'arrowheadStart-style.square'
	| 'arrowheadStart-style.triangle'
	| 'arrowheadEnd-style.none'
	| 'arrowheadEnd-style.arrow'
	| 'arrowheadEnd-style.bar'
	| 'arrowheadEnd-style.diamond'
	| 'arrowheadEnd-style.dot'
	| 'arrowheadEnd-style.inverted'
	| 'arrowheadEnd-style.pipe'
	| 'arrowheadEnd-style.square'
	| 'arrowheadEnd-style.triangle'
	| 'spline-style.line'
	| 'spline-style.cubic'
	| 'arrow-kind-style.arc'
	| 'arrow-kind-style.elbow'
	| 'tool.select'
	| 'tool.hand'
	| 'tool.draw'
	| 'tool.eraser'
	| 'tool.arrow-down'
	| 'tool.arrow-left'
	| 'tool.arrow-right'
	| 'tool.arrow-up'
	| 'tool.arrow'
	| 'tool.cloud'
	| 'tool.diamond'
	| 'tool.ellipse'
	| 'tool.heart'
	| 'tool.hexagon'
	| 'tool.highlight'
	| 'tool.line'
	| 'tool.octagon'
	| 'tool.oval'
	| 'tool.pentagon'
	| 'tool.rectangle'
	| 'tool.rhombus'
	| 'tool.star'
	| 'tool.trapezoid'
	| 'tool.triangle'
	| 'tool.x-box'
	| 'tool.check-box'
	| 'tool.media'
	| 'tool.frame'
	| 'tool.note'
	| 'tool.laser'
	| 'tool.embed'
	| 'tool.text'
	| 'tool.pointer-down'
	| 'tool.image-zoom'
	| 'tool.replace-media'
	| 'tool.flip-horz'
	| 'tool.flip-vert'
	| 'tool.rotate-cw'
	| 'tool.aspect-ratio'
	| 'tool.aspect-ratio.original'
	| 'tool.aspect-ratio.square'
	| 'tool.aspect-ratio.circle'
	| 'tool.aspect-ratio.landscape'
	| 'tool.aspect-ratio.portrait'
	| 'tool.aspect-ratio.wide'
	| 'tool.image-toolbar-title'
	| 'tool.image-crop'
	| 'tool.image-crop-confirm'
	| 'tool.media-alt-text'
	| 'tool.media-alt-text-desc'
	| 'tool.media-alt-text-confirm'
	| 'tool.rich-text-bold'
	| 'tool.rich-text-italic'
	| 'tool.rich-text-code'
	| 'tool.rich-text-highlight'
	| 'tool.rich-text-strikethrough'
	| 'tool.rich-text-link'
	| 'tool.rich-text-link-visit'
	| 'tool.rich-text-link-remove'
	| 'tool.rich-text-header'
	| 'tool.rich-text-bulletList'
	| 'tool.rich-text-toolbar-title'
	| 'tool.rich-text-orderedList'
	| 'tool.bookmark'
	| 'a11y.status'
	| 'a11y.skip-to-main-content'
	| 'a11y.shape-index'
	| 'a11y.shape-image'
	| 'a11y.shape-video'
	| 'a11y.multiple-shapes'
	| 'a11y.select-shape'
	| 'a11y.select-shape-direction'
	| 'a11y.enter-leave-container'
	| 'a11y.repeat-shape'
	| 'a11y.move-shape'
	| 'a11y.move-shape-faster'
	| 'a11y.rotate-shape-cw'
	| 'a11y.rotate-shape-ccw'
	| 'a11y.rotate-shape-cw-fine'
	| 'a11y.rotate-shape-ccw-fine'
	| 'a11y.enlarge-shape'
	| 'a11y.shrink-shape'
	| 'a11y.pan-camera'
	| 'a11y.adjust-shape-styles'
	| 'a11y.open-context-menu'
	| 'a11y.open-keyboard-shortcuts'
	| 'menu.title'
	| 'menu.theme'
	| 'menu.color-theme'
	| 'menu.accessibility'
	| 'menu.copy-as'
	| 'menu.edit'
	| 'menu.export-as'
	| 'menu.file'
	| 'menu.language'
	| 'menu.preferences'
	| 'menu.view'
	| 'menu.input-device'
	| 'context-menu.title'
	| 'context-menu.edit'
	| 'context-menu.arrange'
	| 'context-menu.copy-as'
	| 'context-menu.export-as'
	| 'context-menu.export-all-as'
	| 'context-menu.move-to-page'
	| 'context-menu.reorder'
	| 'page-menu.title'
	| 'page-menu.create-new-page'
	| 'page-menu.max-pages-reached'
	| 'page-menu.new-page-initial-name'
	| 'page-menu.edit-start'
	| 'page-menu.edit-done'
	| 'page-menu.go-to-page'
	| 'page-menu.resize'
	| 'page-menu.submenu.rename'
	| 'page-menu.submenu.duplicate-page'
	| 'page-menu.submenu.title'
	| 'page-menu.submenu.move-down'
	| 'page-menu.submenu.move-up'
	| 'page-menu.submenu.delete'
	| 'share-menu.title'
	| 'share-menu.save-note'
	| 'share-menu.fork-note'
	| 'share-menu.share-project'
	| 'share-menu.copy-link'
	| 'share-menu.create-snapshot-link'
	| 'share-menu.snapshot-link-note'
	| 'share-menu.copy-readonly-link'
	| 'share-menu.offline-note'
	| 'share-menu.copy-link-note'
	| 'share-menu.copy-readonly-link-note'
	| 'share-menu.project-too-large'
	| 'share-menu.upload-failed'
	| 'share-menu.creating-project'
	| 'share-menu.copied'
	| 'document-name-menu.copy-link'
	| 'status.offline'
	| 'people-menu.title'
	| 'people-menu.change-name'
	| 'people-menu.avatar-color'
	| 'people-menu.change-color'
	| 'people-menu.follow'
	| 'people-menu.following'
	| 'people-menu.leading'
	| 'people-menu.user'
	| 'people-menu.invite'
	| 'people-menu.anonymous-user'
	| 'help-menu.import-tldr-file'
	| 'help-menu.title'
	| 'help-menu.about'
	| 'help-menu.discord'
	| 'help-menu.github'
	| 'help-menu.keyboard-shortcuts'
	| 'help-menu.twitter'
	| 'help-menu.terms'
	| 'help-menu.privacy'
	| 'actions-menu.title'
	| 'edit-link-dialog.title'
	| 'edit-link-dialog.invalid-url'
	| 'edit-link-dialog.detail'
	| 'edit-link-dialog.url'
	| 'edit-link-dialog.clear'
	| 'edit-link-dialog.save'
	| 'edit-link-dialog.cancel'
	| 'edit-link-dialog.external-link'
	| 'embed-dialog.title'
	| 'embed-dialog.back'
	| 'embed-dialog.create'
	| 'embed-dialog.cancel'
	| 'embed-dialog.url'
	| 'embed-dialog.instruction'
	| 'embed-dialog.invalid-url'
	| 'shortcuts-dialog.title'
	| 'shortcuts-dialog.edit'
	| 'shortcuts-dialog.file'
	| 'shortcuts-dialog.preferences'
	| 'shortcuts-dialog.tools'
	| 'shortcuts-dialog.transform'
	| 'shortcuts-dialog.view'
	| 'shortcuts-dialog.collaboration'
	| 'shortcuts-dialog.a11y'
	| 'shortcuts-dialog.text-formatting'
	| 'style-panel.title'
	| 'style-panel.align'
	| 'style-panel.label-align'
	| 'style-panel.vertical-align'
	| 'style-panel.position'
	| 'style-panel.arrowheads'
	| 'style-panel.arrowhead-start'
	| 'style-panel.arrowhead-end'
	| 'style-panel.arrow-kind'
	| 'style-panel.color'
	| 'style-panel.dash'
	| 'style-panel.fill'
	| 'style-panel.font'
	| 'style-panel.geo'
	| 'style-panel.mixed'
	| 'style-panel.opacity'
	| 'style-panel.size'
	| 'style-panel.spline'
	| 'style-panel.selected'
	| 'tool-panel.title'
	| 'tool-panel.more'
	| 'navigation-zone.title'
	| 'navigation-zone.minimap'
	| 'navigation-zone.toggle-minimap'
	| 'navigation-zone.zoom'
	| 'focus-mode.toggle-focus-mode'
	| 'toast.close'
	| 'toast.success'
	| 'toast.error'
	| 'toast.info'
	| 'toast.warning'
	| 'file-system.file-open-error.title'
	| 'file-system.file-open-error.not-a-tldraw-file'
	| 'file-system.file-open-error.file-format-version-too-new'
	| 'file-system.file-open-error.generic-corrupted-file'
	| 'file-system.confirm-open.title'
	| 'file-system.confirm-open.description'
	| 'file-system.confirm-open.cancel'
	| 'file-system.confirm-open.open'
	| 'file-system.confirm-open.dont-show-again'
	| 'file-system.confirm-clear.title'
	| 'file-system.confirm-clear.description'
	| 'file-system.confirm-clear.cancel'
	| 'file-system.confirm-clear.continue'
	| 'file-system.confirm-clear.dont-show-again'
	| 'file-system.shared-document-file-open-error.title'
	| 'file-system.shared-document-file-open-error.description'
	| 'sharing.confirm-leave.title'
	| 'sharing.confirm-leave.description'
	| 'sharing.confirm-leave.cancel'
	| 'sharing.confirm-leave.leave'
	| 'sharing.confirm-leave.dont-show-again'
	| 'toast.error.export-fail.title'
	| 'toast.error.export-fail.desc'
	| 'toast.error.copy-fail.title'
	| 'toast.error.copy-fail.desc'
	| 'context.pages.new-page'
	| 'vscode.file-open.desc'
	| 'vscode.file-open.open'
	| 'vscode.file-open.backup'
	| 'vscode.file-open.backup-saved'
	| 'vscode.file-open.backup-failed'
	| 'vscode.file-open.dont-show-again'
	| 'cursor-chat.type-to-chat'
	| 'app.loading'
	| 'handle.resize-top'
	| 'handle.resize-bottom'
	| 'handle.resize-left'
	| 'handle.resize-right'
	| 'handle.resize-top-left'
	| 'handle.resize-top-right'
	| 'handle.resize-bottom-left'
	| 'handle.resize-bottom-right'
	| 'handle.rotate.top_left_rotate'
	| 'handle.rotate.top_right_rotate'
	| 'handle.rotate.bottom_left_rotate'
	| 'handle.rotate.bottom_right_rotate'
	| 'handle.rotate.mobile_rotate'
	| 'handle.crop.top'
	| 'handle.crop.bottom'
	| 'handle.crop.left'
	| 'handle.crop.right'
	| 'handle.crop.top-left'
	| 'handle.crop.top-right'
	| 'handle.crop.bottom-left'
	| 'handle.crop.bottom-right'
	| 'ui.close'
	| 'ui.checked'
	| 'ui.unchecked'
